import { CheckableGroupComponent } from "./chunk-AUZ3GMLH.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckboxGroup/CheckboxGroup.tsx
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var CheckboxGroup = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */jsx(CheckableGroupComponent, __spreadProps(__spreadValues({
    className: clsx("pd:checkbox-group", className)
  }, rest), {
    children: /* @__PURE__ */jsx(CheckableGroupComponent.Fields, {
      className: "pd:checkbox-group__fields",
      children
    })
  }));
};
var CheckboxGroup_default = CheckboxGroup;
export { CheckboxGroup_default };